import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate'
import Regex from '@/const/Regex'
import * as rules from 'vee-validate/dist/rules'
import { defaultApi } from '@/plugins/api/defaultApi'
import { defaultV2Api } from '@/plugins/api/defaultV2Api'

// 규칙 정의
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule])
})

function convert(regName) {
  return {
    validate: (value) => Regex[regName].REGEX.test(value),
    message: Regex[regName].MSG,
  }
}

function checkName(name) {
  //name의 마지막 음절의 유니코드(UTF-16)
  const charCode = name.charCodeAt(name.length - 1)

  //유니코드의 한글 범위 내에서 해당 코드의 받침 확인
  const consonantCode = (charCode - 44032) % 28

  if (consonantCode === 0) {
    //0이면 받침 없음 -> 를
    return `${name}를`
  }
  //1이상이면 받침 있음 -> 을
  return `${name}을`
}

extend('email', convert('EMAIL'))
extend('password', convert('PASSWORD'))
extend('phone', convert('PHONE'))

extend('email_duplicate', {
  validate: async (email) => {
    const { data } = await defaultApi.emailDuplicate(email)
    return data?.isDuplicated === false
  },
  message: '이미 가입된 이메일입니다.',
})

extend('phone_duplicate', {
  validate: async (phone) => {
    try {
      await defaultV2Api.onlyPhoneDuplicate(phone)
      return true
    } catch (e) {
      if (e.status === 400) {
        return e.message
      }
      throw e
    }
  },
})

extend('re_password', {
  validate: (rePassword, [password]) => {
    return password === rePassword
  },
})

// 필드별 메세지
localize('ko', {
  fields: {
    email: {
      required: '이메일 주소를 입력해주세요.',
    },
    password: {
      required: '비밀번호를 입력해주세요.',
    },
    rePassword: {
      required: '비밀번호를 다시 입력해주세요.',
      re_password: '비밀번호가 일치하지 않습니다.',
    },
    phone: {
      required: '휴대폰 번호를 입력해주세요.',
    },
    verify: {
      required: '인증 번호를 입력해주세요.',
      digits: (field, { length }) => {
        return `인증 번호를 ${length}자리로 입력해주세요.`
      },
    },
  },
  messages: {
    required(name) {
      return `${checkName(name)} 입력해주세요.`
    },
  },
})

// Register it globally
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

/**
 *
 * @param {*} errors { email: ['msg1', 'msg2'], password: ['msg3'], ... }
 * @returns ['msg1', 'msg2', 'msg3', ...]
 */
const getAllErrorMessages = (errors) => {
  if (!errors) return
  const fields = Object.getOwnPropertyNames(errors)
  return fields.reduce((arr, cur) => {
    return arr.concat(errors[cur])
  }, [])
}

/**
 *
 * @param {*} errors { email: ['msg1', 'msg2'], password: ['msg3'], ... }
 * @returns 'msg1'
 */
export const getFirstErrorMessage = (errors) => {
  if (!errors) return
  return getAllErrorMessages(errors)[0]
}
